import { QueryHookOptions, TypedDocumentNode, gql } from "@apollo/client";

import {
  GetCurrentUserQuery,
  GetCurrentUserQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { userFragment } from "src/graphql/anti-fraud/fragments/UserFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToUser } from "src/mappers/user.mappers";

export const getCurrentUserQuery = gql`
  query GetCurrentUser {
    currentUser {
      ...UserFragment
    }
  }
  ${userFragment}
` as TypedDocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;

export const useGetCurrentUserQuery = (
  options?: QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>
) => {
  return useFetchQuery(getCurrentUserQuery, {
    queryOptions: options,
    isEmpty: (data) => !data?.currentUser,
    toData: (data) => (data?.currentUser ? mapToUser(data.currentUser) : null),
    uiErrors: {
      fetchError: "UNKNOWN-ERROR",
      emptyError: "UNKNOWN-ERROR",
    },
  });
};
